const config = {
    url: 'http://localhost:3000',
  };
  
  export default config;